<template>
  <div class='SelectSpinner'>
    <div class="label-icon">
      {{ label }}
    </div>
    <div class="btn">
      <component
      @click="SetModal({ component: 'SelectSpinner', active: true })"
      :is="spinner"
      :color="Prefes.spinner.cor"
      :size="spinner === 'EnbSyncLoader' ? '10px' : '30px'"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { loaders } from '@/components/Spinner'
export default {
  name: 'SelectSpinner',
  components: { ...loaders },
  props: ['label', 'spinner'],
  computed: {
    ...mapGetters(['Prefes'])
  },
  methods: {
    ...mapActions(['SetModal'])
  }
}
</script>

<style scoped>
.SelectSpinner {
  display: flex;
  align-items: center;
  padding-top: 2%;
  padding-bottom: 1%;
  font-size: 16px;
}

.label-icon {
  width: 95%;
  padding-left: 1px;
  text-align: left;
}

.btn {
  width: 12%;
  display: flex;
  justify-content: end;
  align-items: center;
}
</style>
